// AI Generated Test
import { Component, Input } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import {
    PageDetailsSeoPagesPagesDialogComponent,
} from '@client/app/components/pagedetails/details/sections/seo/seo-information/pages/page-details-seo-pages-dialog.component';

@Component({
    selector: 'seo-information-duplicate-title',
    standalone: false,
    template: `
        <div class="d-flex align-items-center">
            <div class="mr-auto">
                <strong translate>Title:</strong> <span>{{ seo.content }}</span>
            </div>
            <div>
                <button class="btn btn-border-radius btn-secondary"
                        type="button"
                        (click)="seePages()"
                        translate>
                    See pages
                </button>
            </div>
        </div>
    `,
})
export class SeoInformationDuplicateTitleComponent {
    @Input() seo: any;

    constructor (private monEventService: MonEventService) {}

    seePages (): void {
        const params = {
            body: PageDetailsSeoPagesPagesDialogComponent,
            size: 'lg',
            data: {
                seo: this.seo,
                title: this.seo.content,
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
